










































































































































































import { EventBus } from '@/plugins/event-bus';
import TextToSpeech from "@/components/TextToSpeech.vue";
import SpeechToText from "@/components/SpeechToText.vue";
import{db} from "@/plugins/db"
import { Vue, Component, Prop } from 'vue-property-decorator'
import {ActivityItemInterface} from "@/models/Activity";
@Component({
    components:{
        SpeechToText, TextToSpeech
    }
})
export default class Steepers extends Vue {
    @Prop(String) readonly IdModel: string;
    @Prop(String) readonly path: string;
    public activities: ActivityItemInterface[] = [];
    public response: string | boolean | string[] | number = null ;
    public valid: boolean[] = [];
    public text = '';
    public sentences: any = null;


    validate(){
       if ( this.valid.includes(false) ){
           EventBus.$emit('validate-response', {valid: false, id: this.IdModel});
       }else {
           EventBus.$emit('validate-response', {valid: true, id: this.IdModel});
       }
       
    }


    validateForm(){
        this.valid = [];
        this.activities.forEach((e: ActivityItemInterface) => {               
          if( e.activityQuestion.key === 'VERDADERO_Y_FALSO'){
             if (e.response === e.newResponse){
                 this.valid.push( true)
             }else {
                 this.valid.push( false)
             }
          }                
          if( e.activityQuestion.key === 'RELLENAR_FRASE'){
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const keys: any[] = e.key;

              if(keys.findIndex((el) => el == e.newResponse) != -1){
                  this.valid.push( true)
              }else {
                  this.valid.push( false)
              }
          }

          if( e.activityQuestion.key === 'OPCION_MULTIPLE'){
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                if (e.response == e.newResponse){
                    this.valid.push(true)
                }else {
                    this.valid.push(false)
                }
            }

          if( e.activityQuestion.key === 'BUSCAR_PAR'){
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                if (e.response == e.newResponse){
                    this.valid.push(true)
                }else {
                    this.valid.push(false)
                }
            }

          if( e.activityQuestion.key === 'QUE_HAY_ARCHIVO'){

              const res: string = e.response;
              const newRes = e.newResponse;
            // @ts-ignore
              if (res.toLowerCase() == newRes.toLowerCase()){
                    this.valid.push(true)
                }else {
                    this.valid.push(false)
                }
            }

          if (e.activityQuestion.key === 'TEXTO_VOZ'){
              const textArray = e.newResponse.split(' ');
              const contadortexto: boolean[] = [];
              e.response.forEach((e: any) => {
                  if(textArray.includes(e)){
                      contadortexto.push(true)
                  }else {
                      contadortexto.push(false)
                  }
              });

              if (contadortexto.includes(true)){
                  this.valid.push(true)
              }else {
                  this.valid.push(false)
              }

          }

          if (e.activityQuestion.key === 'PREVIEW'){
              this.valid.push(true)
          }

            if (e.activityQuestion.key === 'ARCHIVO_MULTI_RESPUESTA'){
                const dataResponse: string[] = [];
                const dataBoolean: boolean[] = [];
                e.newResponse.forEach((ac: any) => {
                    dataResponse.push(ac.response)
                });

                e.key.forEach((ele: string) => {
                    if (dataResponse.includes(ele)){
                        dataBoolean.push(true)
                    }else {
                        dataBoolean.push(false)
                    }
                });

                if (dataBoolean.includes(false)){
                    this.valid.push(false)
                }else {
                    this.valid.push(true)
                }


            }


        });
        this.validate()
        
    }
     speechEnd({sentences, text}: { sentences: any; text: any }) {

        this.sentences = sentences
    }

     created(){
        db.doc('clases/'+ this.path)
            .collection('activity')
            .doc(this.IdModel)
            .collection('activities')
            .orderBy('createdAt', 'asc')
            .get().then((data: any) => {
                data.forEach((e: any) => {
                    const d = e.data();
                    d.newResponse = '';
                    if (d.activityQuestion.key === 'VERDADERO_Y_FALSO'){
                        d.newResponse = false;
                    }
                    if (d.activityQuestion.key === 'OPCION_MULTIPLE'){
                        d.newResponse = 0;
                    }

                    if (d.activityQuestion.key === 'ARCHIVO_MULTI_RESPUESTA'){
                        d.newResponse = [];
                        d.key.forEach((a: string) => {
                            d.newResponse.push({
                                response: ''
                            })
                        })
                    }
                    this.activities.push(d)
                })
            });

         EventBus.$on('validate-steep-custom', (id: string) => {
            if (this.IdModel === id){
                this.validateForm();
            }
         });
    }
}
